// extracted by mini-css-extract-plugin
export default {"overlay":"gB-z","bodyOpen":"hB-z","content":"iB-z","header":"jB-z","close":"kB-z","closeNoHeading":"lB-z"};